import React, { useState, useRef } from "react";

const ChatInput = ({ onSend, streaming }) => {
  const [input, setInput] = useState("");
  const textAreaRef = useRef(null);

  const handleSend = () => {
    const messageText = input.trim();
    if (messageText === "") {
      console.warn("Message cannot be empty.");
      return;
    }
    onSend(messageText);
    setInput("");
    if (textAreaRef.current) {
      textAreaRef.current.style.height = "auto";
    }
  };

  const handleKeyDown = (e) => {
    // Send on Enter (no shift)
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="chat-input-bar">
      <textarea
        ref={textAreaRef}
        className="chat-textarea"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Type your question here......"
        rows={1}
        style={{ overflow: "hidden", resize: "none" }}
        autoFocus
      />
      <button
        onClick={handleSend}
        disabled={streaming}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          opacity: streaming ? 0.5 : 1,
          backgroundColor: "#87CEFA", // Light blue background
          borderRadius: "50%",
          width: "45px",
          height: "45px",
          border: "none",
          cursor: "pointer",
          marginRight: "10px", // Added margin here
        }}
      >
        <img
          src="https://iili.io/3d2O1oB.png"
          alt="send"
          style={{ width: "25px", height: "25px" }}
          data-no-invert
        />
      </button>
    </div>

  );
};

export default React.memo(ChatInput);
